"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.23.0
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { EditorTagBadge } from '../../ComboBox/Badges/EditorTagBadge/index.mjs';

const TplFormula = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(EditorTagBadge, { variant: "static-value", ref, onDelete: props.onDelete, children: "Unsupported formula type" });
});
TplFormula.displayName = "TplFormula";

export { TplFormula as default };
